export const SET_DOMAIN_DATA = 'SET_DOMAIN_DATA';
export const SET_DOMAIN_LOADING = 'SET_DOMAIN_LOADING';
export const SET_DOMAIN_ERROR = 'SET_DOMAIN_ERROR';
export const SET_DOMAIN_SUCCESS = 'SET_DOMAIN_SUCCESS';
